export const generateCSP = () => {
    const nonce = Buffer.from(crypto.randomUUID()).toString("base64");
    const cspHeader = `
    default-src 'self' data: blob:;
    script-src 'nonce-${ nonce }' blob: https://www.google.com/recaptcha/ https://www.gstatic.com/recaptcha/ 'unsafe-eval' 'wasm-unsafe-eval';
    script-src-elem 'self' 'unsafe-inline' https://www.google.com/recaptcha/ https://www.gstatic.com/recaptcha/;
    connect-src 'self' https://www.google.com/recaptcha/ https://www.gstatic.com/recaptcha/;
    style-src 'self' data: blob: 'unsafe-inline' 'unsafe-hashes';
    img-src 'self' blob: data:;
    font-src 'self' data:;
    object-src 'none';
    base-uri 'self';
    form-action 'self';
    frame-ancestors 'none';
    upgrade-insecure-requests;
    frame-src 'self' https://www.google.com/;
    `;
    const contentSecurityPolicyHeaderValue = cspHeader
        .replace(/\s{2,}/g, " ")
        .trim();

    return { nonce, csp: contentSecurityPolicyHeaderValue };
};
